/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

export { default as GroupClassmatesPage } from './components/GroupClassmatesPage';
export const GroupClassmatesPageDynamic = () => import('./components/GroupClassmatesPage');

/**
 *  #################################### Generated content ####################################
 **/
